$(function(){
    updateSwiper();
})

$(window).resize(function(){
    updateSwiper();
})




function updateSwiper(){

    $(".custom-list-swiper").each(function(){
      if($(window).width() < 750){
        $(this).attr("slides-per-view", $(this).attr("data-mob"));
      }
      else{
        $(this).attr("slides-per-view", $(this).attr("data-desk"));
      }
    })
    if($(window).width() < 990){
        $(".custom-feed-swiper").attr("slides-per-view", 3);
    }
    else{
        $(".custom-feed-swiper").attr("slides-per-view", 6);
    }
}


document.addEventListener("DOMContentLoaded", function () {

  const rating = document.querySelector(".custom-hero-rating-wrapper");
  const reviews = document.querySelector(".jdgm-widget.jdgm-cards-carousel");

  if (rating && reviews) {
    rating.addEventListener("click", function () {
      reviews.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    });
  }

});
